import {
  MasonryDriverAction,
  MasonrySubmitFormAndReloadAction,
} from '@leagueplatform/masonry-renderers';
import { MasonryEngineActionHandler } from '@leagueplatform/masonry-engine';
import { getVisibleFormFieldNodes } from '../utils/form-validation-utils';
import { submitFormWithValidation } from '../utils/form-submission-base';

/**
 * Submit form and reload action handler
 *
 * This handler submits the form and reloads the specified nodes on success.
 */
export const submitFormAndReloadActionHandler: MasonryEngineActionHandler<
  MasonrySubmitFormAndReloadAction,
  MasonryDriverAction
> = async (
  {
    payload: { formId, formProcessorId, onSuccessReloadNodeIds },
    namespace,
    ancestry,
    event,
  },
  resources,
) => {
  const { stateController, invokeAction } = resources;
  const allFieldNodes = getVisibleFormFieldNodes(formId, stateController);
  const result = await submitFormWithValidation({
    formId,
    formProcessorId,
    fieldNodes: allFieldNodes,
    namespace,
    ancestry,
    event,
    resources,
    isBlocking: true,
  });
  if (result.isSuccess) {
    // If successful, reload the specified nodes
    await invokeAction({
      type: 'reload',
      namespace: 'default',
      payload: { nodeIds: onSuccessReloadNodeIds },
      ancestry,
      event,
    });
  }

  return result;
};
